






























































































import { TypeBody, BaseButton } from '@bambeehr/pollen';
import {
  defineComponent,
  ref,
  onMounted,
  onBeforeUnmount,
  computed,
} from '@nuxtjs/composition-api';
import MFA_TIMER from '@/modules/Settings/constants/Mfa';

export default defineComponent({
  name: 'MfaForm',
  components: {
    TypeBody,
    BaseButton,
  },
  props: {
    header: {
      type: String,
      default: '2-Step Verification',
    },
    subheader: {
      type: String,
      default: 'Enter the verification code we texted to',
    },
    phone: {
      type: String,
      required: false,
    },
    expirationTimer: {
      type: Number,
      default: MFA_TIMER,
    },
  },
  setup(props, { emit }) {
    const otpTextFields = ref();
    const form = ref();

    const handleOtpSubmit = (e?): void => {
      e.preventDefault();
      emit('otpSubmit', form.value);
    };

    const cancelChallenge = (): void => {
      emit('cancelChallenge');
    };

    const timeRemaining = computed(() =>
      new Date(props.expirationTimer)
        .toLocaleString('en-US', {
          minute: '2-digit',
          second: '2-digit',
        })
        .replace(/,/g, '')
    );

    const countdownString = computed(() => {
      return props.expirationTimer > 0
        ? `This code expires in ${timeRemaining.value} minutes`
        : 'This code has expired, please request a new one below.';
    });

    const isCountdownExpired = computed(() => props.expirationTimer < 1);

    onMounted(() => {
      otpTextFields.value = document.querySelectorAll('.otpInput');

      otpTextFields.value.forEach((input, index) => {
        input.addEventListener('keyup', (e) => {
          const valueExists = e.target.value.length > 0;

          // if the input field contains a character, focus the next input field
          if (valueExists && otpTextFields.value[index + 1]) {
            otpTextFields.value[index + 1].focus();
          }

          if (valueExists && otpTextFields.value[index + 1] === undefined) {
            emit('otpSubmit', form.value);
          }

          // if the input field contains a text and backspace is hit, focus the previous input field
          if (
            e?.target?.value.length === 0 &&
            otpTextFields.value[index - 1] &&
            e.key === 'Backspace'
          ) {
            otpTextFields.value[index - 1].focus();
          }

          if (
            otpTextFields.value.forEach((inputVal) => inputVal.value.length > 0)
          ) {
            form.value.submit(handleOtpSubmit);
          }
        });

        input.addEventListener('paste', (e) => {
          const paste = e.clipboardData.getData('text');
          otpTextFields.value.forEach((inputVal, i) => {
            inputVal.value = paste[i];
          });

          otpTextFields.value[5].focus();
        });
      });
    });

    onBeforeUnmount(() => {
      otpTextFields.value.forEach((input) => {
        input.removeEventListener('keyup', () => {});
      });
    });

    return {
      form,
      cancelChallenge,
      countdownString,
      isCountdownExpired,
    };
  },
});
